export const parseCookie = (): Record<string, string> => {
  return document.cookie.split(';').reduce((obj = {}, keyValue) => {
    const [key, value] = keyValue.split('=')
    return {
      ...obj,
      [key.trim()]: value
    }
  }, {})
}
